import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTemplateVideoStyles = makeStyles({
  videoCard: {
    width: '300px',
    filter: 'drop-shadow(0px 0.3px 0.9px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1.6px 3.6px rgba(0, 0, 0, 0.13))',
    ...shorthands.padding(tokens.spacingVerticalNone, tokens.spacingHorizontalNone),
    ...shorthands.borderRadius('6px'),
  },
  videoCardThumbnail: {
    objectFit: 'cover',
    ...shorthands.overflow('hidden'),
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  templateWithCaption: {
    ...shorthands.gap(tokens.spacingVerticalM),
  },
  caption: {
    ...shorthands.gap(tokens.spacingVerticalXS),
  },
  darkGrayText: {
    color: '3B3B4F',
  },
  grayText: {
    color: tokens.colorNeutralForeground3,
  },
});

export const useTemplateGridStyles = makeStyles({
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    rowGap: tokens.spacingVerticalL,
    columnGap: tokens.spacingHorizontalL,
    marginTop: tokens.spacingVerticalXXL,
  },
  skeletonContainer: {
    alignItems: 'center',
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'repeat(5, 1fr)',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  templateBody: {
    paddingTop: '10px',
  },
  filtersRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    marginTop: '15px',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  filterButton: {
    minWidth: 'auto',
    whiteSpace: 'nowrap',
  },
});
